import React from 'react';
import { metrics } from '@atlassian/browser-metrics';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { NonCriticalErrorBoundary } from '../../common/utils/non-critical-error-boundary.tsx';

const versionDetailsPagePageLoad = metrics.pageLoad({
	key: 'software.version-details-page',
	ssr: {
		doneAsFmp: true,
	},
	slo: {
		fmp: {
			initial: { threshold: 1000 },
			transition: { threshold: 1000 },
		},
		tti: {
			initial: { threshold: 4000 },
			transition: { threshold: 4000 },
		},
	},
});

export const PerformanceTracker = () => (
	<NonCriticalErrorBoundary fallback="unmount" eventLocation="performanceTracker">
		<SubmitApdex
			appName="jira-software-version-details-page"
			// @ts-expect-error - TS2769 - No overload matches this call.
			metric={versionDetailsPagePageLoad}
		/>
	</NonCriticalErrorBoundary>
);
